import { useT } from '../../lib/i18n';
import type { Tone } from '@zt/ui';

/**
 * Otomasyon kurucusunun ortak etiketleri (F8-15). i18n anahtarlarında nokta ad alanı ayırıcısıdır; tetikleyici
 * türündeki nokta (`product.created`) anahtarda alt çizgiye çevrilir.
 */
export const key = (s: string) => s.replace(/\./g, '_');

export const FLOW_TONE: Record<string, Tone> = {
  draft: 'slate',
  active: 'moss',
  paused: 'amber',
  archived: 'neutral',
};
export const RUN_TONE: Record<string, Tone> = {
  pending: 'slate',
  running: 'amber',
  succeeded: 'moss',
  failed: 'rose',
  skipped: 'neutral',
  cancelled: 'neutral',
};
export const STEP_TONE: Record<string, Tone> = {
  succeeded: 'moss',
  skipped: 'neutral',
  stopped: 'amber',
  failed: 'rose',
};

/** Çalışma ve adım kodlarının metni: önce kurucuya özgü metin, yoksa genel hata metni. */
export function useWorkflowText() {
  const t = useT();
  const trigger = (type: string) => t(`admin.workflows.triggers.${key(type)}`);
  const action = (type: string) => t(`admin.workflows.actions.${key(type)}`);
  const field = (k: string) => t(`admin.workflows.fields.${k}`);
  const option = (v: string) => t(`admin.workflows.options.${v}`);
  const code = (c: string | null | undefined) => {
    if (!c) return '';
    const own = t(`admin.workflows.codes.${c}`);
    if (own !== `admin.workflows.codes.${c}`) return own;
    const err = t(`errors.${c}`);
    return err === `errors.${c}` ? t('admin.workflows.codes.unknown', { code: c }) : err;
  };
  const reason = (r: string | null | undefined) => {
    if (!r) return '';
    if (r.startsWith('stopped:')) return `${t('admin.workflows.reasons.stopped')}: ${code(r.slice(8))}`;
    return t(`admin.workflows.reasons.${r}`);
  };
  /** Doğrulama sorunu: "Eylem 2 · Konu — Metin çok kısa." */
  const problem = (p: { field: string; code: string }) => {
    const parts = p.field.split('.');
    let where = '';
    if (parts[0] === 'actions' && parts[1] !== undefined && /^\d+$/.test(parts[1]))
      where = t('admin.workflows.problemAction', { n: Number(parts[1]) + 1 });
    else if (parts[0] === 'conditions' && parts[2] !== undefined && /^\d+$/.test(parts[2]))
      where = t('admin.workflows.problemRule', { n: Number(parts[2]) + 1 });
    else if (parts[0] === 'trigger') where = t('admin.workflows.step1');
    else if (parts[0] === 'actions') where = t('admin.workflows.step3');
    const last = parts.at(-1) ?? '';
    const label = t(`admin.workflows.params.${last}`);
    const what = label === `admin.workflows.params.${last}` ? '' : ` · ${label}`;
    return `${where}${what} — ${t(`errors.${p.code}`)}`;
  };
  return { t, trigger, action, field, option, code, reason, problem };
}
